function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { extractElementAttributes, extractElementDataset } from './attributes';
import { getReflexRoots } from './reflexes';
import { uuidv4 } from './utils';
import { elementToXPath } from './utils';
import Schema from './schema';

var ReflexData = /*#__PURE__*/function () {
  function ReflexData(options, reflexElement, controllerElement, reflexController, permanentAttributeName, target, args, url, tabId) {
    _classCallCheck(this, ReflexData);

    this.options = options;
    this.reflexElement = reflexElement;
    this.controllerElement = controllerElement;
    this.reflexController = reflexController;
    this.permanentAttributeName = permanentAttributeName;
    this.target = target;
    this.args = args;
    this.url = url;
    this.tabId = tabId;
  }

  _createClass(ReflexData, [{
    key: "attrs",
    get: function get() {
      this._attrs = this._attrs || this.options['attrs'] || extractElementAttributes(this.reflexElement);
      return this._attrs;
    }
  }, {
    key: "reflexId",
    get: function get() {
      this._reflexId = this._reflexId || this.options['reflexId'] || uuidv4();
      return this._reflexId;
    }
  }, {
    key: "selectors",
    get: function get() {
      this._selectors = this._selectors || this.options['selectors'] || getReflexRoots(this.reflexElement);
      return typeof this._selectors === 'string' ? [this._selectors] : this._selectors;
    }
  }, {
    key: "resolveLate",
    get: function get() {
      return this.options['resolveLate'] || false;
    }
  }, {
    key: "dataset",
    get: function get() {
      this._dataset = this._dataset || extractElementDataset(this.reflexElement);
      return this._dataset;
    }
  }, {
    key: "innerHTML",
    get: function get() {
      return this.includeInnerHtml ? this.reflexElement.innerHTML : '';
    }
  }, {
    key: "textContent",
    get: function get() {
      return this.includeTextContent ? this.reflexElement.textContent : '';
    }
  }, {
    key: "xpathController",
    get: function get() {
      return elementToXPath(this.controllerElement);
    }
  }, {
    key: "xpathElement",
    get: function get() {
      return elementToXPath(this.reflexElement);
    }
  }, {
    key: "formSelector",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexFormSelector] ? this.reflexElement.attributes[Schema.reflexFormSelector].value : undefined;
      return this.options['formSelector'] || attr;
    }
  }, {
    key: "includeInnerHtml",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexIncludeInnerHtml] || false;
      return this.options['includeInnerHTML'] || attr ? attr.value !== 'false' : false;
    }
  }, {
    key: "includeTextContent",
    get: function get() {
      var attr = this.reflexElement.attributes[Schema.reflexIncludeTextContent] || false;
      return this.options['includeTextContent'] || attr ? attr.value !== 'false' : false;
    }
  }, {
    key: "suppressLogging",
    get: function get() {
      return this.options['suppressLogging'] || this.reflexElement.attributes[Schema.reflexSuppressLogging] || false;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      return {
        attrs: this.attrs,
        dataset: this.dataset,
        selectors: this.selectors,
        reflexId: this.reflexId,
        resolveLate: this.resolveLate,
        suppressLogging: this.suppressLogging,
        xpathController: this.xpathController,
        xpathElement: this.xpathElement,
        inner_html: this.innerHTML,
        text_content: this.textContent,
        formSelector: this.formSelector,
        reflexController: this.reflexController,
        permanentAttributeName: this.permanentAttributeName,
        target: this.target,
        args: this.args,
        url: this.url,
        tabId: this.tabId
      };
    }
  }]);

  return ReflexData;
}();

export { ReflexData as default };